import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Code } from "@washingtonpost/wpds-assets";
import { Button, Icon } from "@washingtonpost/wpds-ui-kit";

import { useVideoElementRefContext } from "../../../orca/contexts/VideoElementRefContext";
import { EmbedDialog } from "./EmbedDialog";
import "../index.css";

export const EmbedButton = ({
  videoId,
  headline,
  embedConfig,
  setSelected = () => {},
  isMiniPlayer,
  showEmbedButton = true
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [initialStartSeconds, setInitialStartSeconds] = useState(0);
  const videoElementRef = useVideoElementRefContext();

  const handleOpen = useCallback(
    e => {
      e.stopPropagation();
      setSelected(true);
      const raw = videoElementRef?.current?.currentTime;
      const secs = Number.isFinite(raw) ? Math.floor(raw) : 0;
      setInitialStartSeconds(secs);
      setIsDialogOpen(true);
    },
    [setSelected, videoElementRef]
  );

  const handleOpenChange = useCallback(
    open => {
      setIsDialogOpen(open);

      if (!open) {
        setSelected(false);
      }
    },
    [setSelected]
  );

  if (!videoId) {
    return null;
  }

  return (
    <>
      {showEmbedButton && (
        <Button
          aria-label="Embed video"
          icon="center"
          className="focus-visible-highlight"
          variant="primary"
          css={{
            border: "none",
            background: "none",
            "&:hover": {
              background: "none"
            },
            margin: "-$075",
            padding: "$075"
          }}
          onClick={handleOpen}
        >
          <Icon fill="white" color="white" size={isMiniPlayer ? "100" : "150"}>
            <Code />
          </Icon>
        </Button>
      )}
      <EmbedDialog
        isOpen={isDialogOpen}
        onOpenChange={handleOpenChange}
        videoId={videoId}
        headline={headline}
        embedConfig={embedConfig}
        initialStartSeconds={initialStartSeconds}
      />
    </>
  );
};

EmbedButton.displayName = "EmbedButton";

EmbedButton.propTypes = {
  videoId: PropTypes.string,
  headline: PropTypes.string,
  embedConfig: PropTypes.shape({
    domain: PropTypes.string,
    defaultWidth: PropTypes.number,
    defaultHeight: PropTypes.number,
    queryParams: PropTypes.object,
    getEmbedUrlOverride: PropTypes.func
  }),
  setSelected: PropTypes.func,
  isMiniPlayer: PropTypes.bool.isRequired,
  showEmbedButton: PropTypes.bool
};
